'use client';

import { createContext, useContext } from 'react';

import type { Dispatch, SetStateAction } from 'react';

export interface HeaderContextProps {
  isScrolling: boolean;
  isDesktop: boolean;
  isMobile: boolean;
  isTouchScreen: boolean;
  isTransparent: boolean;
  setIsTransparent: Dispatch<SetStateAction<boolean>>;
  height: number;
}

type x = HeaderContextProps extends Record<string, unknown> ? 'true' : 'false';

const defaultValue: HeaderContextProps = {
  isScrolling: false,
  isDesktop: true,
  isMobile: false,
  isTouchScreen: false,
  isTransparent: false,
  setIsTransparent: () => void 0,
  height: 100,
};

export const HeaderContext = createContext( defaultValue );

export const HeaderContextProvider = HeaderContext.Provider;

export const useHeader = (): HeaderContextProps => useContext( HeaderContext );
